import { render, staticRenderFns } from "./detailsNew.vue?vue&type=template&id=8fe52ed6"
import script from "./detailsNew.vue?vue&type=script&lang=js"
export * from "./detailsNew.vue?vue&type=script&lang=js"
import style0 from "./detailsNew.vue?vue&type=style&index=0&id=8fe52ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports